<div class="modal-header">
    <h4 class="modal-title">{{'hospitalDashboard_employeeSelect_title' | translate}}</h4>
</div>

<form #filterForm="ngForm">
    <div class="form-field">
        <input class="form-control"
               [placeholder]="'hospitalDashboard_employeeSelect_search' | translate"
               [(ngModel)]="searchTerm"
               name="searchTerm"
               (input)="filter()">
    </div>
</form>

<app-table [rows]="rows" [columns]="columns" [pageSize]="5" [style]="'plain'">
    <ng-template #rowTemplate let-row>
        <tr>
            <td>
                <div>{{row.Name}} {{row.Surname}}</div>
                <div class="text-sub">{{row.Email}}</div>
            </td>
            <td>
                <div *ngFor="let n of row.Companies">
                    <ng-container *ngIf="row.Companies.length > 1">&mdash; </ng-container>
                    {{n}}
                </div>
            </td>
            <td>
                <button type="button" class="btn btn-icon btn-outline" (click)="select(row)">
                    <i class="fi fi-rs-angle-right"></i>
                </button>
            </td>
        </tr>
    </ng-template>
</app-table>

<div class="modal-footer">
    <button class="btn btn-outline-secondary" type="button" (click)="cancel()">{{'cancel' | translate}}</button>
</div>
